var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
      [
        _c("c-table", {
          ref: "equipmentGradeTable",
          attrs: {
            title: "LBL0003314",
            tableId: "equipmentGradeTable",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            "hide-bottom": true,
            "hide-pagination": true,
            isFullScreen: false,
            columnSetting: false,
            filtering: false,
          },
          on: { rowClick: _vm.rowClick },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
      [
        _c(
          "q-form",
          { ref: "editForm" },
          [
            _c(
              "c-card",
              {
                staticClass: "cardClassDetailForm",
                attrs: { title: "LBL0003315" },
              },
              [
                _c(
                  "template",
                  { slot: "card-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable && _vm.addMode
                          ? _c("c-btn", {
                              attrs: { label: "LBLREG", icon: "add" },
                              on: { btnClicked: _vm.addRank },
                            })
                          : _vm._e(),
                        _vm.editable && _vm.revisionMode
                          ? _c("c-btn", {
                              attrs: { label: "LBLREV", icon: "restart_alt" },
                              on: { btnClicked: _vm.revisionRank },
                            })
                          : _vm._e(),
                        _vm.editable
                          ? _c("c-btn", {
                              attrs: {
                                url: _vm.saveUrl,
                                isSubmit: _vm.isSave,
                                param: _vm.data,
                                mappingType: _vm.saveType,
                                label: "LBLSAVE",
                                icon: "save",
                              },
                              on: {
                                beforeAction: _vm.saveRank,
                                btnCallback: _vm.saveCallback,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("template", { slot: "card-detail" }, [
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("c-select", {
                        attrs: {
                          required: true,
                          codeGroupCd: "MDM_EQUIP_GRADE_CD",
                          type: "edit",
                          itemText: "codeName",
                          itemValue: "code",
                          name: "grade",
                          label: "LBL0003316",
                          editable: _vm.editable && _vm.updateMode,
                        },
                        model: {
                          value: _vm.data.grade,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "grade", $$v)
                          },
                          expression: "data.grade",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("c-datepicker", {
                        attrs: {
                          required: true,
                          editable: _vm.editable && _vm.updateMode,
                          label: "LBL0003317",
                          name: "gradeDate",
                        },
                        model: {
                          value: _vm.data.gradeDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "gradeDate", $$v)
                          },
                          expression: "data.gradeDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("c-text", {
                        attrs: {
                          required: true,
                          editable: _vm.editable && _vm.updateMode,
                          label: "LBL0003318",
                          type: "number",
                          name: "estimationScore",
                        },
                        model: {
                          value: _vm.data.estimationScore,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "estimationScore", $$v)
                          },
                          expression: "data.estimationScore",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("c-textarea", {
                        attrs: {
                          required: true,
                          editable: _vm.editable && _vm.updateMode,
                          label: "LBL0003319",
                          name: "changeReason",
                        },
                        model: {
                          value: _vm.data.changeReason,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "changeReason", $$v)
                          },
                          expression: "data.changeReason",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("c-upload", {
                        attrs: { editable: _vm.editable, label: "LBL0003320" },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }